export default __webpack_public_path__ + "static/media/face-augments.23f53d10.svg";